import AsyncSelectField from "../FormFields/AsyncSelectField";
import { useState } from "react";
import useGlobalProvider from "../../../lib/providers/globalProvider";
import { useDefunti } from "../../../lib/hooks/api/defunti";

function DefuntoSearchField({
  field,
  handleOnChange,
  isSingleSelect,
  isClearable = true,
  compressed = false,
  fullWidth = false,
  append = null,
  helpText = null,
  additionalQuery = {},
}) {
  const { currentComuneId } = useGlobalProvider();
  const [searchQuery, setSearchQuery] = useState({});
  const { defunti, isFetching, isLoading } = useDefunti(
    currentComuneId,
    {
      page: 0,
      pageSize: 20,
      query: { ...searchQuery, ...additionalQuery },
      sort: { cognome: 1, nome: 1 },
    },
    false
  );

  const handleSearchChange = (searchValue) => {
    const andConditions = [];

    searchValue.split(" ").forEach((seed) => {
      andConditions.push({
        $or: [
          { cognome: { $regex: ".*" + seed + ".*", $options: "i" } },
          { nome: { $regex: ".*" + seed + ".*", $options: "i" } },
          { codiceFiscale: { $regex: ".*" + seed + ".*", $options: "i" } },
        ],
      });
    });

    setSearchQuery({
      $and: andConditions,
    });
  };

  return (
    <AsyncSelectField
      field={field}
      isSingleSelect={isSingleSelect}
      handleOnChange={handleOnChange}
      handleSearchChange={handleSearchChange}
      options={defunti.data.map((defunto) => ({
        code: defunto._id,
        label: `${defunto.cognome} ${defunto.nome}${
          defunto.codiceFiscale ? " - " + defunto.codiceFiscale : ""
        }`,
      }))}
      isLoading={isLoading || isFetching}
      isClearable={isClearable}
      compressed={compressed}
      fullWidth={fullWidth}
      append={append}
      helpText={helpText}
    />
  );
}

export default DefuntoSearchField;
